import { z } from "zod";

export const PROJECT_TYPES = [
  "Web Design",
  "Graphic Design",
  "Copywriting & Content",
  "Photography",
  "Video Production",
  "Software Development",
  "Consulting",
  "Social Media Management",
  "Other Creative Services",
] as const;

export const PAYMENT_TERMS = [
  "50% upfront, 50% on completion",
  "100% upfront before work begins",
  "3 equal installments (start, midpoint, completion)",
  "Monthly retainer (billed on the 1st)",
  "Net 30 (full payment due 30 days after delivery)",
] as const;

export const intakeSchema = z.object({
  project_type: z.enum(PROJECT_TYPES),
  freelancer_name: z.string().min(1).max(120),
  client_name: z.string().min(1).max(160),
  client_email: z
    .string()
    .email()
    .optional()
    .or(z.literal("").transform(() => undefined)),
  project_title: z.string().min(1).max(200),
  scope: z.string().min(10).max(4000),
  deliverables: z.string().min(5).max(4000),
  start_date: z.string().min(1),
  end_date: z.string().min(1),
  total_price: z.number().min(0).max(10_000_000),
  payment_terms: z.enum(PAYMENT_TERMS),
});

export type IntakeInput = z.infer<typeof intakeSchema>;
